import React from 'react'

import { object, string, bool } from 'prop-types'

import Hamburger from './Components/Hamburger/Hamburger'
import Logo from './Components/Logo/Logo'
import Menu from './Components/Menu/Menu'
import Search from './Components/Search/Search'
import UserActions from './Components/UserActions/UserActions'
import { useHamburgerStatus } from './Hooks/useHamburgerStatus'

function Navigation({
  commonRoutes,
  locale = 'en',
  isInListingPage = false,
  searchInputValue = '',
  searchPlaceholder,
}) {
  const { root } = commonRoutes
  const { isActive, toggle } = useHamburgerStatus()

  return (
    <div className="unified-nav">
      <Hamburger isActive={isActive} onToggle={toggle} />
      <Logo url={root} />
      <Search
        locale={locale}
        isInListingPage={isInListingPage}
        searchInputValue={searchInputValue}
        searchPlaceholder={searchPlaceholder}
      />
      <Menu isActive={isActive} />
      <UserActions />
    </div>
  )
}

Navigation.propTypes = {
  commonRoutes: object.isRequired,
  locale: string,
  isInListingPage: bool,
  searchInputValue: string,
  searchPlaceholder: string.isRequired,
}

export default Navigation
